module.exports = __webpack_public_path__ + "img/tsonev.7397e56a.jpg";